import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Paper, SvgIcon } from '@material-ui/core';

const alignCenter = {
    margin: '0 auto'
}

const useStyles = makeStyles({
    root: {
        position: 'absolute',
    },
    left: {
        left: 10,
    },
    right: {
        right: 10
    },
    list: {
        minWidth: 200
    },
    listItem: {
        
    },
    contentsContainer: {        
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    subheaderContainer: {
        ...alignCenter,
        paddingTop: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    itemTitle: {

    },
    headerImageContainer: {
        ...alignCenter,
        marginLeft: 10,
        marginRight: 10,
        marginTop: 10,
        paddingTop: 10,
    },
    headerImage: {
        ...alignCenter,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    detailsButtonContainer: {
      margin: '0 auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    detailsButton: {
        marginBottom: 10
    }
});

export default function PropertyDetailsBox({ propertyDetailsData, title, headerImageURL, hasMoreButton, onMoreButtonClick, headerElement, containerType = 'paper', contentPadding = 0, ...props }) {    
    const classes = useStyles();    
    
    if (propertyDetailsData) {
        
        const titleMaxLength = 35;
        const shortTitle = title && title.length > titleMaxLength ? title.substring(0,titleMaxLength) + '...' : title;        
        return (        
            <Paper {...props}>
                {
                    headerElement
                }                          
                <div style={{"position":"absolute","top":"10px","left":"10px","background":"rgba(0, 0, 0, 0.75)","padding":"4px 8px","color":"white","margin":"0"}}>
                    {shortTitle}
                </div>   
                <div style={{"position":"absolute","bottom":"10px","right":"10px","background":"rgba(0, 0, 0, 0.75)","padding":"4px 8px","color":"white","margin":"0"}}>
                    <SvgIcon onClick={onMoreButtonClick}>
                        <path d="M10,21V19H6.41L10.91,14.5L9.5,13.09L5,17.59V14H3V21H10M14.5,10.91L19,6.41V10H21V3H14V5H17.59L13.09,9.5L14.5,10.91Z" />
                    </SvgIcon>                 
                </div>                   
                <div className={classes.detailsButtonContainer}>
                    <span>
                        {`${propertyDetailsData.propertySubtype}, ${propertyDetailsData.yearBuilt}yb ${propertyDetailsData.beds}be/${propertyDetailsData.fullBaths}ba ${propertyDetailsData.livingAreaSqFt ? propertyDetailsData.livingAreaSqFt + 'sqft' : ''}`}
                    </span>                             
                </div>                
            </Paper>
        )
    } else {
        return (        
            <>
            </>
        )
    }
}
